export const worksummery = {
  remaining: {
    works: 4,
    vendors: 9,
    amountCr: 2,
  },
  completed: {
    works: 10,
    vendors: 4,
    amountCr: 4,
  },
  inProgress: {
    works: 5,
    vendors: 4,
    amountCr: 12,
  },
};
